var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.536,
    height: 17.618,
    viewBox: "0 0 18.536 17.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,1.333a.5.5,0,0,1,.943,0L11.47,6.228a.5.5,0,0,0,.459.333l5.192.133a.5.5,0,0,1,.291.9L13.29,10.747a.5.5,0,0,0-.175.539l1.478,4.976a.5.5,0,0,1-.763.554L9.551,13.874a.5.5,0,0,0-.567,0L4.705,16.817a.5.5,0,0,1-.763-.554l1.478-4.976a.5.5,0,0,0-.175-.539L1.124,7.59a.5.5,0,0,1,.291-.9l5.192-.133a.5.5,0,0,0,.459-.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStar);
export default __webpack_public_path__ + "static/media/BlackStar.01ca7b5a1d7c7412201fa3be3c2f5455.svg";
export { ForwardRef as ReactComponent };